import Link from "next/link";
import { BlockProps } from "../BlocksManager/registry";


function renderMarkedRemise(nom: string) {
  const parts = nom.split(/(\[.*?\])/g);

  return parts.map((part, index) => {
    const isHighlighted = part.startsWith("[") && part.endsWith("]");

    if (isHighlighted) {
      const text = part.slice(1, -1);

      return (
        <span
          key={index}
          className="text-[40px] text-white md:text-[70px]"
        >
          <br />
          {text}
          <br />
        </span>
      );
    }

    return <span key={index}>{part}</span>;
  });
}

export default function Remise({ data }: BlockProps) {
  if (!data) return null;

  return (
    <section className="relative overflow-hidden bg-violet px-6 py-14 text-white md:px-10 lg:px-16">
      {/* Cercles décoratifs */}
      <div className="absolute left-8 -top-16 h-28 w-28 rounded-full bg-orange " />
      <div className="lg:absolute hidden lg:block right-[-80px] top-[-60px] h-44 w-44 rounded-full bg-orange md:right-[50px] md:top-[-140px] md:h-72 md:w-72" />
      <div className="absolute bottom-[-28px] left-[18%] h-20 w-20 rounded-full bg-orange md:h-24 md:w-24" />
      <div className="absolute bottom-[54px] right-[32%] h-16 w-16 rounded-full bg-orange md:h-20 md:w-20" />

      <div className="relative z-10 mx-auto max-w-[1350px] lg:block hidden">
        <div className="grid items-center gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
          {/* Bloc texte */}
          <div className="max-w-[780px]">
            <h2 className="font-literata text-[30px] font-bold leading-[1.12] text-white sm:text-[42px] lg:text-[46px]">
              {data?.titre}
            </h2>

            <p className="mt-6 max-w-[760px] font-body text-[22px] leading-[1.35] text-white/95 sm:text-[24px] lg:mt-8 lg:text-[30px]">
              {data?.description} <Link href={"/conditions-generales-de-vente"} className="font-bold underline">
                voir les conditions
              </Link>
            </p>
          </div>

          {/* Badge */}
          <div className="flex justify-center ">
            <div className="relative">


              {/* Badge orange */}
              <div className="relative flex h-[210px] w-[260px] rotate-[10deg] items-center justify-center rounded-[200px] bg-orange border-[14px] border-violet px-6 text-center shadow-[0_24px_50px_rgba(46,34,120,0.35)] md:h-[280px] md:w-[340px] md:px-8">
                <p className="rotate-[2deg] whitespace-pre-line font-heading text-[22px] font-extrabold leading-[1.02] text-white md:text-[34px]">
                  {renderMarkedRemise(data?.remise)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile - badge en haut à droite */}
      <div className="relative lg:hidden">
        {/* Badge */}
        <div className="absolute left-[200px] top-[5px] z-20">
          <div className="relative shrink-0">
            <div className="absolute left-[6px] top-[8px] h-[150px] w-[150px] rotate-[10deg] rounded-[999px] bg-violet/50" />
            <div className="relative flex h-[150px] w-[150px] rotate-[10deg] items-center justify-center rounded-[999px] bg-orange px-2 text-center shadow-[0_24px_50px_rgba(46,34,120,0.35)]">
              <p className="-rotate-[10deg] whitespace-pre-line font-heading text-[15px] font-extrabold leading-[1.05] text-white">
                {renderMarkedRemise(data?.remise || "")}
              </p>
            </div>
          </div>
        </div>

        {/* Titre */}
        <div className="relative z-10 max-w-[60%] ">
          <h3 className="font-literata text-[24px] font-bold leading-[1.1] text-white">
            {data?.titre}
          </h3>
        </div>

        {/* Description */}
        <p className="relative z-10 mt-6 max-w-[92%] font-body text-[17px] leading-[1.35] text-white/95">
          {data?.description}{" "}
          <Link
            href={"/conditions-generales-de-vente"}
            className="font-bold underline"
          >
            voir les conditions
          </Link>
        </p>
      </div>

    </section>
  );
}